module.exports = __webpack_public_path__ + "static/media/teachersnote_logo_big.5ee50e12.png";